{
  "cycle.entite.organisation_cles_api": "Clés d’API de l’organisation",
  "cycle.entite.organisation_cles_api_rotations": "Remplacements de clés d’API",
  "journalAudit.action.org.api_key.created": "Clé d’API créée",
  "journalAudit.action.org.api_key.revoked": "Clé d’API révoquée",
  "journalAudit.action.org.api_key.rotated": "Clé d’API remplacée",
  "journalAudit.action.org.api_key.rotation_abandoned": "Remplacement de clé d’API abandonné",
  "journalAudit.action.org.api_key.taken_over": "Clé d’API reprise",
  "journalAudit.action.org.api_key.used": "Appel par clé d’API",
  "v8c.clesapi.annuler": "Annuler",
  "v8c.clesapi.choisir": "Choisir…",
  "v8c.clesapi.code.CLE_DEJA_REVOQUEE": "Cette clé est déjà révoquée.",
  "v8c.clesapi.code.CLE_DROITS_HORS_PORTEE": "Vous ne tenez pas vous-même un droit choisi sur cette portée.",
  "v8c.clesapi.code.CLE_DROIT_NON_DELEGABLE": "Un droit choisi n’est jamais délégable à une clé.",
  "v8c.clesapi.code.CLE_EXPIRATION_INVALIDE": "Date d’expiration invalide : future, un an au plus, différente de l’ancienne.",
  "v8c.clesapi.code.CLE_NOM_DEJA_UTILISE": "Une clé de ce nom existe déjà dans l’organisation.",
  "v8c.clesapi.code.CLE_NON_SUSPENDUE": "Cette clé n’est pas suspendue.",
  "v8c.clesapi.code.CLE_REPRENEUR_SANS_LES_DROITS": "Le repreneur ne tient pas tous les droits de la clé sur sa portée.",
  "v8c.clesapi.code.CLE_ROTATION_EXPIREE": "Remplacement abandonné (délai dépassé) : la nouvelle clé est révoquée, l’ancienne reste valable.",
  "v8c.clesapi.code.CLE_ROTATION_RESPONSABLE_OU_DROITS_CHANGES": "Le responsable ou ses droits ont changé depuis l’ouverture : rien n’est révoqué.",
  "v8c.clesapi.code.CLE_SUSPENDUE_REPRENDRE_D_ABORD": "Clé suspendue : reprenez-la d’abord.",
  "v8c.clesapi.code.DROIT_NON_TENU": "Vous ne tenez pas le droit de gérer les clés d’API.",
  "v8c.clesapi.code.RESOURCE_UNAVAILABLE": "Clé introuvable.",
  "v8c.clesapi.code.VALIDATION_ERROR": "Saisie incomplète ou invalide.",
  "v8c.clesapi.col.actions": "Actions",
  "v8c.clesapi.col.derniere_utilisation": "Dernière utilisation",
  "v8c.clesapi.col.expire_le": "Expire le",
  "v8c.clesapi.col.nom": "Nom",
  "v8c.clesapi.col.portee": "Portée",
  "v8c.clesapi.col.responsable": "Responsable",
  "v8c.clesapi.col.statut": "Statut",
  "v8c.clesapi.creer.aucun_droit": "Vous ne tenez aucun droit délégable sur cette portée.",
  "v8c.clesapi.creer.aucun_espace": "Aucun espace accessible de ce type.",
  "v8c.clesapi.creer.bouton": "Créer la clé",
  "v8c.clesapi.creer.bouton_ouvrir": "Créer une clé d’API",
  "v8c.clesapi.creer.choix_programme": "Programme",
  "v8c.clesapi.creer.choix_projet": "Projet",
  "v8c.clesapi.creer.droits": "Droits de la clé",
  "v8c.clesapi.creer.droits_proposables": "Droits proposables",
  "v8c.clesapi.creer.echec": "La clé n’a pas été créée.",
  "v8c.clesapi.creer.espaces": "Vos espaces",
  "v8c.clesapi.creer.exclus": "{{n}} droit(s) jamais délégable(s) à une clé",
  "v8c.clesapi.creer.expiration": "Date d’expiration",
  "v8c.clesapi.creer.expiration_aide": "Obligatoire : 30 jours par défaut, un an au plus.",
  "v8c.clesapi.creer.faite": "Clé créée : conservez son secret maintenant.",
  "v8c.clesapi.creer.nom": "Nom",
  "v8c.clesapi.creer.nom_invalide": "Le nom est requis (100 caractères au plus).",
  "v8c.clesapi.creer.plafond": "Seuls les droits que vous tenez vous-même sur la portée choisie sont proposés.",
  "v8c.clesapi.creer.portee": "Portée",
  "v8c.clesapi.creer.portee_d_abord": "Choisissez d’abord le programme ou le projet de la portée.",
  "v8c.clesapi.creer.titre": "Créer une clé d’API d’organisation",
  "v8c.clesapi.creer.usage": "Usage (facultatif)",
  "v8c.clesapi.etat.chargement": "Chargement : {{quoi}}…",
  "v8c.clesapi.etat.en_cours": "En cours…",
  "v8c.clesapi.etat.erreur": "Lecture impossible : {{quoi}}.",
  "v8c.clesapi.etat.introuvable": "{{quoi}} introuvable.",
  "v8c.clesapi.etat.reessayer": "Réessayer",
  "v8c.clesapi.etat.refus": "Accès refusé : {{quoi}}.",
  "v8c.clesapi.exclusion.decision_humaine": "décision humaine (valider, publier, approuver)",
  "v8c.clesapi.exclusion.personnel": "droit personnel",
  "v8c.clesapi.exclusion.reserve_au_proprietaire": "réservé au propriétaire",
  "v8c.clesapi.expiration.ancienne": "Choisissez une date différente de celle de l’ancienne clé.",
  "v8c.clesapi.expiration.obligatoire": "Date d’expiration obligatoire (AAAA-MM-JJ).",
  "v8c.clesapi.expiration.passee": "Cette date est déjà passée.",
  "v8c.clesapi.expiration.un_an": "Une clé expire dans un an au plus.",
  "v8c.clesapi.fiche.creee_par": "Créée par",
  "v8c.clesapi.fiche.droits_et_portee": "Droits et portée",
  "v8c.clesapi.fiche.effectifs": "Droits effectifs : {{n}} sur {{total}}, plafonnés par ceux du responsable et recalculés à chaque appel.",
  "v8c.clesapi.fiche.expire_le": "Expire le {{date}}",
  "v8c.clesapi.fiche.identite": "Identité de la clé",
  "v8c.clesapi.fiche.identite_de_service": "Identité de service de l’organisation",
  "v8c.clesapi.fiche.journal_attribue": "Chaque appel est écrit au journal au nom de la clé et de son responsable au moment de l’appel.",
  "v8c.clesapi.fiche.libelle": "Clé d’API",
  "v8c.clesapi.fiche.parti": "a quitté l’organisation",
  "v8c.clesapi.fiche.plafonne": "non tenu par le responsable",
  "v8c.clesapi.fiche.portee": "Portée : {{portee}}",
  "v8c.clesapi.fiche.reprise_par": "Reprise par",
  "v8c.clesapi.fiche.responsable": "Responsable en fonction",
  "v8c.clesapi.fiche.revoquee_le": "Révoquée le {{date}} par {{nom}}",
  "v8c.clesapi.fiche.titre": "Clé d’API de l’organisation",
  "v8c.clesapi.jamais_utilisee": "Jamais utilisée",
  "v8c.clesapi.liste.intro": "Une clé agit au nom de l’organisation, attribuée à son responsable ; son secret n’est montré qu’une fois.",
  "v8c.clesapi.liste.libelle": "Clés d’API",
  "v8c.clesapi.liste.titre": "Clés d’API de l’organisation",
  "v8c.clesapi.liste.vide": "Aucune clé d’API dans l’organisation.",
  "v8c.clesapi.onglet.apercu": "Aperçu",
  "v8c.clesapi.onglet.cles": "Clés d’API",
  "v8c.clesapi.onglets": "Sections de l’organisation",
  "v8c.clesapi.portee.organisation": "Toute l’organisation",
  "v8c.clesapi.portee.programme": "Programme",
  "v8c.clesapi.portee.projet": "Projet",
  "v8c.clesapi.remplacer.annuler_apres": "Annuler maintenant révoque la nouvelle clé ; l’ancienne reste valable.",
  "v8c.clesapi.remplacer.bouton_ouvrir": "Remplacer la clé",
  "v8c.clesapi.remplacer.cesse_maintenant": "L’ancienne clé cessera de fonctionner dès la confirmation.",
  "v8c.clesapi.remplacer.confirmer": "Confirmer et révoquer l’ancienne clé",
  "v8c.clesapi.remplacer.conserver_d_abord": "Cochez d’abord « J’ai conservé le secret ».",
  "v8c.clesapi.remplacer.conserves": "Portée {{portee}}, droits et responsable ({{responsable}}) conservés.",
  "v8c.clesapi.remplacer.creer": "Créer la nouvelle clé",
  "v8c.clesapi.remplacer.echec": "La nouvelle clé n’a pas été créée.",
  "v8c.clesapi.remplacer.echec_abandon": "L’abandon n’a pas abouti : la nouvelle clé n’est peut-être pas révoquée ; réessayez « Annuler ».",
  "v8c.clesapi.remplacer.echec_confirmation": "Le remplacement n’a pas été confirmé.",
  "v8c.clesapi.remplacer.en_attente": "La nouvelle clé reste en attente jusqu’à votre confirmation (au plus tard {{echeance}}) ; ce secret ne sera plus jamais affiché.",
  "v8c.clesapi.remplacer.expiration": "Expiration de la nouvelle clé",
  "v8c.clesapi.remplacer.expiree": "L’ancienne clé est expirée : choisissez la nouvelle expiration.",
  "v8c.clesapi.remplacer.revoquee": "Cette clé a été révoquée entre-temps : rien à remplacer.",
  "v8c.clesapi.remplacer.suspendue": "Clé suspendue : reprenez d’abord la responsabilité de cette clé.",
  "v8c.clesapi.remplacer.titre": "Remplacer une clé d’API",
  "v8c.clesapi.reprise.aucun": "Aucun membre ne tient tous les droits de cette clé sur sa portée.",
  "v8c.clesapi.reprise.bouton": "Reprendre la clé",
  "v8c.clesapi.reprise.choisir_d_abord": "Choisissez d’abord un repreneur.",
  "v8c.clesapi.reprise.echec": "La reprise n’a pas été enregistrée.",
  "v8c.clesapi.reprise.explication": "Son responsable {{nom}} a quitté l’organisation : la clé est suspendue jusqu’à sa reprise par un membre qui tient ses droits.",
  "v8c.clesapi.reprise.faite": "Clé reprise : elle est de nouveau active.",
  "v8c.clesapi.reprise.repreneur": "Repreneur",
  "v8c.clesapi.reprise.repreneurs": "Repreneurs possibles",
  "v8c.clesapi.revocation.bouton": "Révoquer la clé",
  "v8c.clesapi.revocation.confirmation": "Révoquer « {{nom}} » ? L’effet est immédiat et définitif : tout appel avec cette clé sera refusé.",
  "v8c.clesapi.revocation.confirmer": "Révoquer définitivement",
  "v8c.clesapi.revocation.echec": "La clé n’a pas été révoquée.",
  "v8c.clesapi.revocation.faite": "Clé révoquée.",
  "v8c.clesapi.secret.case_conserve": "J’ai conservé le secret",
  "v8c.clesapi.secret.conserve": "J’ai conservé le secret",
  "v8c.clesapi.secret.copie": "Secret copié.",
  "v8c.clesapi.secret.copie_refusee": "Le navigateur a refusé la copie : sélectionnez le secret et copiez-le.",
  "v8c.clesapi.secret.copier": "Copier le secret",
  "v8c.clesapi.secret.quitter": "Le secret ne sera plus jamais affiché. Quitter quand même ?",
  "v8c.clesapi.secret.quitter_confirmer": "Quitter",
  "v8c.clesapi.secret.rester": "Rester",
  "v8c.clesapi.secret.titre": "Secret de la clé",
  "v8c.clesapi.secret.titre_nouveau": "Secret de la nouvelle clé",
  "v8c.clesapi.secret.une_fois": "Ce secret n’est montré qu’une fois : copiez-le maintenant dans votre coffre.",
  "v8c.clesapi.secret.valeur": "Secret",
  "v8c.clesapi.statut.active": "Active",
  "v8c.clesapi.statut.en_attente_de_confirmation": "En attente de confirmation",
  "v8c.clesapi.statut.expire_bientot": "Expire bientôt",
  "v8c.clesapi.statut.expiree": "Expirée",
  "v8c.clesapi.statut.revoquee": "Révoquée",
  "v8c.clesapi.statut.suspendue": "Suspendue",
  "v8c.clesapi.toutes_les_cles": "Toutes les clés",
  "v8c.clesapi.utilisations.libelle": "Utilisations récentes",
  "v8c.clesapi.utilisations.ligne": "{{date}} — {{methode}} {{chemin}} depuis {{adresse}} (responsable {{responsable}})",
  "v8c.clesapi.utilisations.titre": "Utilisations récentes",
  "v8c.clesapi.utilisations.vide": "Aucune utilisation enregistrée.",
  "v8c.clesapi.voir": "Voir",
  "v8c.clesapi.voir_la_cle": "Voir la clé {{nom}}"
}
